export default __webpack_public_path__ + "images/8235f7367e6199d71d62948b32e39a0d.png";